import { useQuery, useQueryClient } from '@tanstack/react-query'
import { Table } from 'antd'
import React, { useState } from 'react'
import { useHistory } from 'react-router-dom'
import { getCases } from '../../api/arendeApi'
import ViewHeader from '../../components/viewHeader/ViewHeader'
import { caseTableScrollX, createCaseTableConfig } from '../../components/tablesConfig/caseTableConfig'
import HandlingDetailsModal from './components/handleFlag/HandlingDetailsModal'

/**
 * En flagga som ingår i en hantering.
 *
 * Stod tidigare som `DataType`, vilket var fel form: backend bygger objektet med
 * flaggans namn i `namn` (inte `flaggnamn`), och `target_type` — som avgör om flaggan
 * rör en brukare, personal eller utförare — saknades helt i typen trots att den
 * skickas. Den behövs för att veta vilken behörighet en länk till flaggan kräver.
 */
export type CaseFlag = {
  id: number
  type: number
  /** Flaggans namn, t.ex. "Bristande personalkontinuitet". */
  namn: string
  nivå: number
  created: Date
  från: string
  till: string
  /** 'b' brukare · 'm' personal · 'u' utförare. */
  target_type: string
  target_id: number
}

export type Case = {
  key: React.Key
  id: number
  visible: boolean
  /** Typ av hantering (#30). 'uppföljning' för rader skapade via gamla flödet. */
  kind: 'avfärdad' | 'hanterad' | 'uppföljning'
  /** Stabila nycklar; etiketterna slås upp i reasons.ts. Null för uppföljning. */
  sub_reasons: string[] | null
  ägare: { id: number; namn: string }
  flags: CaseFlag[]
  handläggare: { id: number; namn: string }[]
  händelser: CaseLogs[]
  created: Date
  senastUppdaterad: Date
  status: string
}

export type CaseLogs = {
  id: number
  date: Date
  status: string
  type: string
  comment: string
  createdBy: { id: number; namn: string }
}

const Case = () => {
  const navigate = useHistory()
  const queryClient = useQueryClient()
  const [detaljer, setDetaljer] = useState<Case | null>(null)

  const { isLoading, isError, data: cases } = useQuery(['cases'], getCases)

  if (isError || !cases) return null

  const columns = createCaseTableConfig(cases, navigate, setDetaljer)

  return (
    <>
      <ViewHeader heading="Hanterade flaggor" />
      <Table
        columns={columns}
        dataSource={cases}
        loading={isLoading}
        pagination={false}
        bordered
        size="small"
        // Fasta kolumner kräver ett scroll.x — utan det ignorerar antd `fixed`.
        scroll={{ x: caseTableScrollX(columns) }}
      />
      <HandlingDetailsModal
        hantering={detaljer}
        onClose={() => setDetaljer(null)}
        onRetracted={() => {
          setDetaljer(null)
          queryClient.invalidateQueries(['cases'])
        }}
      />
    </>
  )
}

export default Case
